module.exports = "<!-- Generated by IcoMoon.io -->\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n<title>dehaze</title>\n<path d=\"M2.016 5.484h19.969v2.016h-19.969v-2.016zM2.016 10.5h19.969v2.016h-19.969v-2.016zM2.016 15.516h19.969v1.969h-19.969v-1.969z\"></path>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/svg/dehaze.svg
// module id = 814
// module chunks = 0